import { render, staticRenderFns } from "./IngredientTemplate.vue?vue&type=template&id=d2683060&scoped=true"
import script from "./IngredientTemplate.vue?vue&type=script&lang=js"
export * from "./IngredientTemplate.vue?vue&type=script&lang=js"
import style0 from "./IngredientTemplate.vue?vue&type=style&index=0&id=d2683060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2683060",
  null
  
)

export default component.exports